import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const updateBranchStatusClient = async (redBody) => {
    const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.updateBranchStatus()}`;

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(redBody),
    });

    if (!res.ok) {
        return { error: true, message: 'Branch status update request failed', status: res.status, data: [] };
    }
    const getData = await res.json();
    return { status: res.status, data: getData };
};

export default updateBranchStatusClient;
